import { createEffect, onMount } from 'solid-js';
import { Viewer, Ion, Terrain, Entity } from 'cesium';
import './cesium.scss';
import { useStateContext } from '../context';
import { createJobSource } from './JobDescription/Jobs.ts';
import { createEduSource } from './EducationDescription/edu.ts';
import { useMapContext } from './MapContext.tsx';
import { Toolbar } from './Toolbar/Toolbar.tsx';
import { createTravelSource } from './TravelDescription/travel.ts';

export default function CesiumMap() {
    let state = useStateContext();
    let map = useMapContext();
    let cesiumContainer!: HTMLDivElement;
    onMount(() => {
        let creditContainer = document.createElement('div');
        Ion.defaultAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhZTNlNmVlMi05NzA5LTQxOGEtYTk2Ny1kYThiZTFlNWVlNzciLCJpZCI6MjYxMjA0LCJpYXQiOjE3MzM3NjU3NDZ9.D8ZDYTP88vbroZZMqva_M703x2tpLf3Bsuj3VNTLZH4";
        const viewer = new Viewer(cesiumContainer, {
            creditContainer,
            timeline: false,
            animation: false,
            baseLayerPicker: false,
            fullscreenButton: false,
            terrain: Terrain.fromWorldTerrain(),
            infoBox: false,
        });
        viewer.entities.suspendEvents();
        let jobSource = createJobSource();
        let eduSource = createEduSource();
        let travelSource = createTravelSource();
        viewer.dataSources.add(jobSource);
        viewer.dataSources.add(eduSource);
        viewer.dataSources.add(travelSource);
        viewer.selectedEntityChanged.addEventListener((entity: Entity) => {
            if (!Entity) {
                state.setSelectedEntity(null);
                return;
            }
            state.setSelectedEntity(entity);
        });
        viewer.entities.resumeEvents();
        createEffect(() => {
            map.isJobsShown() ? jobSource.show = true : jobSource.show = false;
        });
        createEffect(() => {
            map.isEduShown() ? eduSource.show = true : eduSource.show = false;
        });
        createEffect(() => {
            map.isTravelShown() ? travelSource.show = true : travelSource.show = false;
        });

        return () => viewer.destroy();
    });

    return (
        <>
            <div ref={cesiumContainer} class="map" />
            <Toolbar />
        </>
    );
}
